export const MAIN_CLASS_NAME = 'recognizer-selector';
export const GROUP_CLASS_NAME = `${MAIN_CLASS_NAME}__group`;
export const BLOCK_CLASS_NAME = `${GROUP_CLASS_NAME}__block`;
export const TITLE_CLASS_NAME = `${BLOCK_CLASS_NAME}__title`;
